module.exports = __webpack_public_path__ + "6f8fe02cc950eb7937fc7df6c24e5a37.svg";